import { instance } from '../config/api';

/**
 * @typedef {Object} ChartData
 * @property {string[]} labels
 * @property {number[]} data
 */

/**
 * @param {number} currency - Currency ID
 * @returns {Promise<Object.<string, ChartData>>}
 */
const fetchCurrencyGraph = async (currency) => {
  const { data } = await instance.get(`transaction/graph?currency_id=${currency}`);
  if (data.data) {
    const formattedData = {};
    for (let key in data.data) {
      formattedData[key] = {};
      const section = formattedData[key] ?? {};
      const currentData = data.data[key] ?? {};
      section.labels = Object.keys(currentData);
      section.data = Object.values(currentData);
    }
    return formattedData;
  }
  return data;
};
export { fetchCurrencyGraph };
